//  Copyright © Veeam Software Group GmbH

import React from 'react';
import { DataGrid } from '@veeam/components';

import { useResources } from '../../../../infrastructure/resources';
import { useColumns } from './hooks/useColumns';
import { useToolbar } from './hooks/useToolbar';
import { useEvents } from './hooks/useEvent';

import type { SessionsModel } from './hooks/useModel';

export interface SessionsGridProps {
    model: SessionsModel;
}

export const SessionsGrid: React.FC<SessionsGridProps> = ({ model }) => {
    const resources = useResources().features.RestoreSessions.SessionsGrid;
    const columns = useColumns(resources);
    const toolbar = useToolbar(resources, model);

    useEvents(model);

    return (
        <DataGrid
            model={model}
            columns={columns}
            toolbar={toolbar}
            config={{
                canResizeColumns: true,
                columnsToggleable: true,
            }}
        />
    );
};